import Grid from '@mui/material/Grid';

import useResponsive from '@/hooks/useResponsive';

interface MapSectionProps {
  map?: boolean;
  mapLoading: boolean;
  mapUrl: string;
}

const MapSection = ({ map, mapLoading, mapUrl }: MapSectionProps) => {
  const isTablet = useResponsive('up', 'lg');
  const isMobile = useResponsive('down', 'sm');

  if (!map || isMobile) {
    return null;
  }

  return (
    <Grid width={!isTablet ? 1 : 0.45}>
      {mapLoading ? (
        <img
          style={{
            width: '45%',
            height: '25%',
            borderRadius: '1.5rem',
            filter: 'blur(15px)',
            transition: 'filter 1s ease',
            maxHeight: '450px',
            margin: '0 auto',
          }}
          src="https://trackingservicev2.s3.us-east-2.amazonaws.com/assets/dummy.map.png"
          alt="alterPic"
        />
      ) : (
        <img
          src={mapUrl}
          alt="map"
          style={{
            height: '25%',
            borderRadius: '1.5rem',
            maxHeight: '450px',
            margin: '0 auto',
          }}
        />
      )}
    </Grid>
  );
};

export default MapSection;
